function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["bodyProps", "className", "disabled", "error", "errorProps", "headerProps", "helpText", "helpTextProps", "id", "label", "labelPosition", "labelProps", "look", "maxLength", "minLength", "name", "onBlur", "onChange", "placeholder", "readOnly", "required", "requiredLabel", "showLabel", "textareaProps", "value", "wrapperRef"],
  _excluded2 = ["labelPosition", "look", "showLabel"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { forwardRef, useContext } from 'react';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import { InputLabelPositions, InputLooks } from "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import { baseInputStyle, getInputBorderRadius, getInputPadding, getInputTheme } from "../../../../styles/styled-components/input.js";
import "../../../../styles/styled-components/list.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import "../../../internal/list/standard-list/standard-list.js";
import "../../../internal/listbox/standard-listbox/standard-listbox.js";
import "../../../internal/listitem/standard-listitem/standard-listitem.js";
import "../../../internal/option/standard-option/standard-option.js";
import "../../../internal/textarea/fake-textarea.js";
import "../../../internal/textfield/textfield-addon.js";
import { TextfieldBody } from "../../../internal/textfield/textfield-body.js";
import { TextfieldHeader } from "../../../internal/textfield/textfield-header.js";
import "../../../internal/textfield/textfield-icon.js";
import "../../../internal/textfield/textfield-inner.js";
import { TextfieldWrapper } from "../../../internal/textfield/textfield-wrapper.js";
import { BaseTextarea } from "../base-textarea/base-textarea.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var BaseStandardTextarea = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classnames;
  var bodyProps = props.bodyProps,
    className = props.className,
    disabled = props.disabled,
    error = props.error,
    errorProps = props.errorProps,
    headerProps = props.headerProps,
    helpText = props.helpText,
    helpTextProps = props.helpTextProps,
    id = props.id,
    label = props.label,
    labelPosition = props.labelPosition,
    labelProps = props.labelProps,
    look = props.look,
    maxLength = props.maxLength,
    minLength = props.minLength,
    name = props.name,
    onBlur = props.onBlur,
    onChange = props.onChange,
    placeholder = props.placeholder,
    readOnly = props.readOnly,
    required = props.required,
    requiredLabel = props.requiredLabel,
    showLabel = props.showLabel,
    textareaProps = props.textareaProps,
    value = props.value,
    wrapperRef = props.wrapperRef,
    otherProps = _objectWithoutProperties(props, _excluded);
  var hasError = !!error;
  var hasHelpText = !!helpText;
  var hasRequired = required && !!requiredLabel;
  var helpTextId = "".concat(id, "-help-text");
  var inlineAlertId = "".concat(id, "-inline-alert");
  return /*#__PURE__*/React.createElement(TextfieldWrapper, _extends({}, otherProps, {
    className: classnames((_classnames = {
      'bf-textarea__standard': true,
      'bf-textarea__standard--disabled': disabled,
      'bf-textarea__standard--error': hasError,
      'bf-textarea__standard--help-text': hasHelpText,
      'bf-textarea__standard--label-hidden': !showLabel
    }, _defineProperty(_classnames, "bf-textarea__standard--label-".concat(labelPosition), showLabel), _defineProperty(_classnames, "bf-textarea__standard--look-".concat(look), look), _defineProperty(_classnames, 'bf-textarea__standard--placeholder', !!placeholder), _defineProperty(_classnames, 'bf-textarea__standard--readonly', readOnly), _defineProperty(_classnames, 'bf-textarea__standard--required', hasRequired), _defineProperty(_classnames, "".concat(className), !!className), _classnames)),
    labelPosition: labelPosition,
    ref: wrapperRef
  }), /*#__PURE__*/React.createElement(TextfieldHeader, _extends({}, headerProps, {
    className: classnames(_defineProperty({
      'bf-textarea__header': true
    }, "".concat(headerProps === null || headerProps === void 0 ? void 0 : headerProps.className), !!(headerProps !== null && headerProps !== void 0 && headerProps.className))),
    error: error,
    errorProps: errorProps,
    htmlFor: id,
    inlineAlertId: inlineAlertId,
    label: label,
    labelPosition: labelPosition,
    labelProps: labelProps,
    required: required,
    requiredLabel: requiredLabel,
    showLabel: showLabel
  })), /*#__PURE__*/React.createElement(TextfieldBody, _extends({}, bodyProps, {
    className: classnames(_defineProperty({
      'bf-textarea__body': true
    }, "".concat(bodyProps === null || bodyProps === void 0 ? void 0 : bodyProps.className), !!(bodyProps !== null && bodyProps !== void 0 && bodyProps.className))),
    error: error,
    errorProps: errorProps,
    helpText: helpText,
    helpTextId: helpTextId,
    helpTextProps: helpTextProps,
    inlineAlertId: inlineAlertId,
    labelPosition: labelPosition
  }), /*#__PURE__*/React.createElement(BaseTextarea, _extends({}, textareaProps, {
    "aria-describedby": hasError ? inlineAlertId : hasHelpText ? helpTextId : undefined,
    "aria-disabled": disabled,
    "aria-invalid": hasError,
    className: classnames(_defineProperty({
      'bf-textarea__textarea': true
    }, "".concat(textareaProps === null || textareaProps === void 0 ? void 0 : textareaProps.className), !!(textareaProps !== null && textareaProps !== void 0 && textareaProps.className))),
    disabled: disabled,
    id: id,
    maxLength: maxLength,
    minLength: minLength,
    name: name,
    onBlur: onBlur,
    onChange: onChange,
    placeholder: placeholder,
    readOnly: readOnly,
    ref: ref,
    required: required,
    value: value
  }))));
});
var Textarea = styled(BaseStandardTextarea)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  .bf-textarea__textarea {\n    ", "\n    ", "\n    ", "\n    ", "\n  }\n"])), baseInputStyle, getInputBorderRadius({}), getInputPadding({}), function (_ref) {
  var error = _ref.error,
    look = _ref.look;
  return getInputTheme({
    error: error,
    look: look
  });
});
/**
 * A `<textarea>` element, which allows multi-line plain-text editing. `id` and `label` are required for accessibility.
 *
 * When `InputLabelPositions.Left`is set, apply a `width` or `max-width` on `.bf-textfield__header`.
 * See Textfield [examples](https://brandfolder.com/designsystem/?path=/docs/components-molecules-textfields--examples)
 * for recommended CSS styling.
 *
 * https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea
 *
 * @param props StandardTextareaProps
 * @returns FunctionComponent<StandardTextareaProps>
 */
var StandardTextarea = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$labelPosition = props.labelPosition,
    labelPosition = _props$labelPosition === void 0 ? InputLabelPositions.Top : _props$labelPosition,
    _props$look = props.look,
    look = _props$look === void 0 ? InputLooks.Default : _props$look,
    _props$showLabel = props.showLabel,
    showLabel = _props$showLabel === void 0 ? true : _props$showLabel,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Textarea, _extends({}, otherProps, {
    labelPosition: labelPosition,
    look: look,
    ref: ref,
    showLabel: showLabel
  })));
});
export { StandardTextarea };